import React from 'react';
import { ReactComponent as Trash } from '../../../assets/icons/trash.svg';
import { ReactComponent as BackButton } from '../../../assets/icons/backConfigurationIcon.svg';
import { useTranslation } from 'react-i18next';

type Type = {
	design?: any;
	removeObject?: (data: any) => void;
};

function EditDesignHeader({ design, removeObject = () => {} }: Type) {
	const { t } = useTranslation();
	return (
		<div className="flex flex-row justify-between items-center mt-[15px] pb-[15px] font-bold border-b border-b-[#D4C4F6]">
			<div className="flex flex-row gap-[10px] items-center">
				<button className="h-[21.67px] w-[21.67px] rounded-full bg-[#D1D5DB] flex items-center justify-center" onClick={() => removeObject(design)}>
					<BackButton />
				</button>
				<label htmlFor="style your text" className="uppercase text-[14px] leading-[25px] truncate max-w-[430px]">
					{t('style your design')} - <span className="font-normal">{design.designName}</span>
				</label>
			</div>
			<button onClick={() => removeObject(design)} className="px-[15px]">
				<Trash />
			</button>
		</div>
	);
}

export default EditDesignHeader;
